import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyGuestSiteBody = loadable(() => import(/* webpackChunkName: "content/guest/site/body" */ './GuestSiteBody'));
